import type { AdminApplication, AdminTenant } from './models';
import { payApiClient } from './client';

/** The contract's maximum page size — used to drain a listing in as few calls as possible. */
const MAX_PAGE_SIZE = 200;

/**
 * Drains every page of `GET /v1/admin/tenants`, for the comboboxes that
 * filter client-side over the whole catalog (the platform's tenant count is
 * a few hundred at most, well within one or two pages).
 */
export async function fetchAllAdminTenants(): Promise<AdminTenant[]> {
  const all: AdminTenant[] = [];
  for (let page = 1; ; page += 1) {
    const response = await payApiClient.listAdminTenants({ page, pageSize: MAX_PAGE_SIZE });
    all.push(...response.items);
    if (response.items.length === 0 || page >= response.page.totalPages) return all;
  }
}

/** `fetchAllAdminTenants`'s counterpart for `GET /v1/admin/applications`. */
export async function fetchAllAdminApplications(): Promise<AdminApplication[]> {
  const all: AdminApplication[] = [];
  for (let page = 1; ; page += 1) {
    const response = await payApiClient.listAdminApplications(page, MAX_PAGE_SIZE);
    all.push(...response.items);
    if (response.items.length === 0 || page >= response.page.totalPages) return all;
  }
}
